// ANETT HORVATH — Brandhouse Configuration
// Central config: all constants live here. No hardcoded values elsewhere.

export const TIER_ORDER = ['INITIATE','INNER_CIRCLE','FOUNDING_CIRCLE','COLLECTOR','BLACK_CARD'] as const;
export type Tier = typeof TIER_ORDER[number];

export const TIER_THRESHOLDS: Record<Tier, number> = {
  INITIATE: 0,
  INNER_CIRCLE: 3333,
  FOUNDING_CIRCLE: 6666,
  COLLECTOR: 9999,
  BLACK_CARD: 111111,
};

export const TIER_LABELS: Record<Tier, string> = {
  INITIATE: 'Initiate',
  INNER_CIRCLE: 'Inner Circle',
  FOUNDING_CIRCLE: 'Founding Circle',
  COLLECTOR: 'Collector',
  BLACK_CARD: 'Black Card',
};

export const LOGIN_MAX_ATTEMPTS = 5;
export const LOGIN_WINDOW_MINUTES = 15;
export const LOCK_DURATION_MINUTES = 30;
export const GRACE_PERIOD_DAYS = 30;
export const MEMBERSHIP_YEAR_DAYS = 365;
export const SCHEDULER_INTERVALS = { daily: 86400000, hourly: 3600000 };
export const ALLOWED_MEDIA_DOMAINS = ['images.unsplash.com','cdn.anetthorvath.com','res.cloudinary.com'];
export const MEDIA_MAX_SIZE = 10 * 1024 * 1024; // 10MB
export const SUPPORTED_LANGUAGES = ['en','hu','de','it','fr'] as const;
export type SupportedLang = typeof SUPPORTED_LANGUAGES[number];
export const DEFAULT_LANGUAGE: SupportedLang = 'en';

export const MEMBER_STATUSES = ['waitlist','active','paused','revoked'] as const;
export type MemberStatus = typeof MEMBER_STATUSES[number];
export const MEMBERSHIP_STATES = ['inactive','active','grace_period','expired','lifetime'] as const;
export type MembershipState = typeof MEMBERSHIP_STATES[number];
export const ORDER_STATUSES = ['pending','paid','refunded','cancelled'] as const;
export type OrderStatus = typeof ORDER_STATUSES[number];
export const ORDER_SOURCES = ['manual_admin','stripe','external_shop','concierge'] as const;
export type OrderSource = typeof ORDER_SOURCES[number];
export const RELEASE_STATUSES = ['upcoming','live_private','live_public','closed'] as const;
export type ReleaseStatus = typeof RELEASE_STATUSES[number];
export const INVITE_STATUSES = ['active','consumed','expired','revoked'] as const;
export type InviteStatus = typeof INVITE_STATUSES[number];
export const ADMIN_ROLES = ['super_admin','house_admin','editor','support'] as const;
export type AdminRole = typeof ADMIN_ROLES[number];
export const CATEGORY_STATUSES = ['active','hidden','retired'] as const;
export type CategoryStatus = typeof CATEGORY_STATUSES[number];

// Tiers eligible for invite creation
export const INVITE_ELIGIBLE_TIERS: Tier[] = ['FOUNDING_CIRCLE','COLLECTOR','BLACK_CARD'];

// Protected terms — never translated
export const PROTECTED_TERMS = ['Brandhouse','House','Inner Circle','Founding Circle','Collector','Black Card'];

// House phases
export const HOUSE_PHASES = ['closed','preparation','allocation_open','production','archive'] as const;
export type HousePhase = typeof HOUSE_PHASES[number];

// Deposit amount
export const DEPOSIT_AMOUNT_EUR = 222;

// Notification types
export const NOTIFICATION_TYPES = ['approval','allocation_open','allocation_confirmed','phase_change','arrival','legal_update','general'] as const;
export type NotificationType = typeof NOTIFICATION_TYPES[number];

// Scheduler intervals (extended)
export const SCHEDULER_EXTENDED = {
  notification_retry: 900000,    // 15 minutes
  house_state_sync: 3600000,     // 1 hour
  waiting_phase_check: 86400000, // daily
  restore_cleanup: 86400000,     // daily
};

